import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { LoadingScreen } from "../Loaders";
import { useRefreshToken } from "../../features/Authentication";
import { getParamString } from "../../utils/mapData";
import LoadingScreen2 from "../Loaders/LoadingScreen2";

function CheckAuth({ path, children }) {
  const { auth } = useSelector((state) => state.authProvider);
  const location = useLocation();
  const [firstLoad, setFirstLoad] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();

  const param = getParamString(searchParams.entries());

  // Authenticating remembered user
  const { refresh: refreshToken, loading: refreshingToken } = useRefreshToken();

  useEffect(() => {
    if (
      location.state?.prevPath == "/sign-up" ||
      location.state?.prevPath == "/login"
    )
      return;
    console.log("refreshing");
    refreshToken();
    setFirstLoad(false);
  }, [refreshToken]);

  // if (refreshingToken) return <LoadingScreen />;
  if (refreshingToken) return <LoadingScreen2 />;

  if (path === "/") {
    if (firstLoad) return;

    if (auth?.accessToken) return <Navigate to={"/app"} />;

    return <Navigate to={"/welcome"} />;
  }

  if (path === "login") {
    if (auth?.accessToken)
      return (
        <Navigate
          to={{
            pathname: location.state?.prevPath || "/app",
            search: location.state?.search,
          }}
        />
      );
  }

  if (path === "app") {
    if (!auth?.accessToken) {
      return (
        <Navigate
          to={"/login"}
          state={{ prevPath: location.pathname, search: param }}
        />
      );
    }
  }

  return children;
}

export default CheckAuth;
